/* eslint-disable no-unused-vars */

export const isAdminSelector = (state) => {
  const authObj = state?.auth;
  if (Object.prototype.hasOwnProperty.call(authObj, 'pb_roles')) {
    const roles = authObj.pb_roles;
    return roles?.includes('admin');
  } else {
    return false;
  }
};

export const isAdvertiserRole = (state) => {
  const authObj = state?.auth;
  if (Object.prototype.hasOwnProperty.call(authObj, 'pb_roles')) {
    const roles = authObj.pb_roles;
    return roles?.includes('advertiser');
  } else {
    return false;
  }
};

export const isPublisherRole = (state) => {
  const authObj = state?.auth;
  if (Object.prototype.hasOwnProperty.call(authObj, 'pb_roles')) {
    const roles = authObj.pb_roles;
    return roles?.includes('publisher');
  } else {
    return false;
  }
};
